import { createContext, useContext } from 'react';
import { useActor } from '@xstate/react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Context = createContext(undefined);
export const { Provider: PaymentFlowProvider } = Context;
const usePaymentFlowMachine = () => {
    const [paymentFlow, paymentFlowMachine] = useContext(Context);
    const [currentPaymentActorRef, send] = useActor(paymentFlowMachine);
    return [
        paymentFlow,
        currentPaymentActorRef,
        send
    ];
};
export default usePaymentFlowMachine;
